export const getGigCoverImage = (gallery) => {
    const slides = gallery?.slides;

    if (!Array.isArray(slides)) {
        return undefined;
    }

    for (const item of slides) {
        const slide = item?.slide || item;
        const image = slide?.thumbnail || slide?.media?.small || slide?.media?.medium;

        if (typeof image === 'string' && image) {
            return image;
        }
    }

    return undefined;
};
